import React from "react";
import { IconButton, Tooltip, CircularProgress, Theme } from "@mui/material";
import { Mic } from "lucide-react";

interface RecordButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isInitializing?: boolean;
  theme: Theme;
}

const RecordButton: React.FC<RecordButtonProps> = ({
  onClick,
  disabled = false,
  isInitializing = false,
  theme,
}) => (
  <Tooltip title="Tap to record" placement="top" arrow>
    <span>
      <IconButton
        onClick={onClick}
        disabled={disabled || isInitializing}
        sx={{
          width: 32,
          height: 32,
          borderRadius: theme.nawy.radius.full,
          backgroundColor: theme.nawy.colors.semantic.layer.accentLight,
          color: theme.nawy.colors.semantic.layer.accent,
          "&:hover": {
            backgroundColor: theme.nawy.colors.semantic.border.accent,
            color: theme.nawy.colors.semantic.layer.primary,
          },
          "&:disabled": {
            backgroundColor:
              theme.nawy.colors.semantic.layer.extension.disabledLight,
            color: theme.nawy.colors.semantic.text.extension.disabled,
          },
        }}
      >
        {isInitializing ? <CircularProgress size={16} /> : <Mic size={16} />}
      </IconButton>
    </span>
  </Tooltip>
);

export default RecordButton;
